export default "__VITE_ASSET__BuwAC5$z__"